module.exports = __webpack_public_path__ + "img/meetings-parasole.e16fc3b.jpeg";